"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);

// The patient's consent status and history, for orgs with the CONSENT bit
// (`isActive`). Loads again whenever `refreshKey` changes (the patient's
// texting rows, so an opt-out or resubscribe shows here too). Null while
// loading, on failure, and outside consent orgs.
 const usePatientConsent = (
  orgKey,
  patientKey,
  isActive,
  refreshKey,
) => {
  const [view, setView] = _react.useState(null)
  const key = `${orgKey}|${patientKey}`

  _react.useEffect.call(void 0, () => {
    if (!isActive) return undefined
    let isCurrent = true
    _actions2.default.getPatientConsent({ OrgKey: orgKey, PatientKey: patientKey })
      .then(v => { if (isCurrent) setView({ key, view: v }) })
      .catch(() => undefined)
    return () => { isCurrent = false }
  }, [isActive, key, orgKey, patientKey, refreshKey])

  // A save returns the new view; show it.
  const update = _react.useCallback.call(void 0, (v) => setView({ key, view: v }), [key])

  const current = isActive && _optionalChain([view, 'optionalAccess', _ => _.key]) === key ? view.view : null
  return { view: _optionalChain([current, 'optionalAccess', _2 => _2.Enabled]) ? current : null, update }
}; exports.usePatientConsent = usePatientConsent

exports. default = exports.usePatientConsent
